import React, { useEffect, useState } from "react";
import useDebounce from "../../../hooks/useDebounceHook";
import { ApiGet } from "../../../helpers/API/ApiData";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import { TailSpin } from "react-loader-spinner";
import { customStyles } from "../tableStyle";
import { Trash } from "react-feather";
import { Button } from "reactstrap";
import Moment from "react-moment";
import { Modal } from "react-bootstrap";
import { Input, Label } from "reactstrap";
import moment from "moment";
import DatePicker from "react-datepicker";
import Select from "react-select";
import { downloadExcel } from "../../../helpers/Common";
// import DownloadFilterModel from "../../commonComponent/donwloadFilterModel";
import { Margin } from "react-to-pdf";

function LocationDetails() {
  const currentUrl = window.location.href;
  const url = new URL(currentUrl);
  const id = url.searchParams.get("id");
  const [getEventData, setGetEventData] = useState();
  const [searchValue, setSearchValue] = useState("");
  const [page, setPage] = useState(1);
  const [countPerPage, setCountPerPage] = useState(10);
  const [count, setCount] = useState(0);
  const [filterData, setFilterData] = useState({});
  // const navigate = useNavigate()

  const [loading, setLoading] = useState(false);
  const debouncedSearchValue = useDebounce(searchValue, 900);
  const [isShowManageModel, setIsShowManageModel] = useState(false);
  const [isShowPlateModels, setIsShowPlateModels] = useState(false);
  const [error, setError] = useState({});
  const [inputValue, setInputValue] = useState({
    authPlates: [{ id: 1, plateNumber: "" }],
  });
  const [allPlatesValue, setAllPlatesValue] = useState([]);
  const [donwloadModel, setDonwloadModel] = useState({
    isOpen: false,
    startDate: null,
    endDate: null,
    violateOption: null,
    loading: false,
  });

  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [violateOption, setViolateOption] = useState();

  const isAssignViolateOption = [
    {
      value: '',
      label: "Alle",
    },
    {
      value: true,
      label: "verletzen",
    },
    {
      value: false,
      label: "nicht flüchtig",
    },
  ];

  const columns = [
    {
      name: "SNo",
      cell: (row, index) => {
        return <p>{(page - 1) * countPerPage + index + 1}</p>;
      },
      width: "60px",
    },
    {
      name: <span>Kennzeichen</span>,
      width: "250px",
      selector: (row) => {
        return <div>{row.plateNumber ? row.plateNumber : "-"}</div>;
      },
    },
    // {
    //   name: <span>Datum </span>,
    //   minWidth: "200px",
    //   selector: (row) => <div className="profileImage">{row.createdAt ? <Moment format="DD-MM-YYYY , HH:mm:ss" tz="CET" date={row.createdAt} /> : "-"}</div>,
    // },

    // {
    //   name: "Geräte-ID",
    //   width: "200px",
    //   selector: (row) => <div className="profileImage">{row.deviceId ? row.deviceId : "-"}</div>,
    // },
    // {
    //   name: "Richtung",
    //   width: "200px",
    //   selector: (row) => <div className="profileImage">{row.direction ? row.direction : "-"}</div>,
    // },
    {
      name: <span>Eintrittszeit </span>,
      minWidth: "200px",
      selector: (row) => <div className="profileImage">{row.entryTime ? <Moment format="DD-MM-YYYY , HH:mm:ss" tz="CET" date={row.entryTime} /> : "-"}</div>,
    },
    {
      name: <span>Austrittszeit</span>,
      minWidth: "200px",
      // selector: (row) => <div className="profileImage">{row.exitTime ? moment(row.exitTime).format("MMM D, YYYY, HH:mm:ss") : "-"}</div>,
      selector: (row) => <div className="profileImage">{row.exitTime ? <Moment format="DD-MM-YYYY , HH:mm:ss" tz="CET" date={new Date(row.exitTime)} /> : "-"}</div>,
    },

    {
      name: "Parkzeit",
      width: "200px",
      selector: (row) => <div className="profileImage">{row.totalParkingTime ? row.totalParkingTime + " Minuten" : "-"}</div>,
    },

    {
      name: "Abstrafungen",
      width: "200px",
      selector: (row) => {
        const statusClass = row?.isViolation ? "new-deisgn-statusooooooooooo" : "newstatusppppppppppp";
        return <div className={statusClass}>{row.isViolation ? "Ja" : "NEIN"}</div>;
      },
    },

    // {
    //   minWidth: "150px",
    //   name: "Aktion",
    //   selector: (row) => (
    //     <div className="actionColumn">

    //       <Button
    //         size="sm"
    //         color="transparent"
    //         className="btn btn-icon"
    //         onClick={() => {
    //         //   handleEditLocation(row);
    //         }}
    //       >
    //         <svg width="20px" height="20px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{ cursor: "pointer" }}>
    //           <title />

    //           <g id="Complete">
    //             <g id="edit">
    //               <g>
    //                 <path d="M20,16v4a2,2,0,0,1-2,2H4a2,2,0,0,1-2-2V6A2,2,0,0,1,4,4H8" fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />

    //                 <polygon fill="none" points="12.5 15.8 22 6.2 17.8 2 8.3 11.5 8 16 12.5 15.8" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
    //               </g>
    //             </g>
    //           </g>
    //         </svg>
    //       </Button>

    //       <Button
    //         size="sm"
    //         color="transparent"
    //         className="btn btn-icon"
    //         onClick={() => {
    //         //   handleConfirmDelete(row);
    //         }}
    //       >
    //         <Trash className="font-medium-2" />
    //       </Button>
    //     </div>
    //   ),
    // },
  ];

  useEffect(() => {
    handleChangeCommom("", "", filterData);
  }, [debouncedSearchValue, page, countPerPage, violateOption, filterData]);

  const handleChangeCommom = async (e, key, filter) => {
    setLoading(true);

    try {
      const response = await ApiGet(
        `dahualocation/getLocationEvents?locationId=${id}&limit=${countPerPage}&page=${page}${debouncedSearchValue ? `&search=${searchValue}` : ""}${violateOption?.value ? `&isViolation=${violateOption?.value}` : ""}${filter?.startDate ? `&startDate=${filter?.startDate}` : ""
        }${filter?.endDate ? `&endDate=${filter?.endDate}` : ""}`
      );
      setCount(response?.data?.payload.totalCount);
      setGetEventData(response?.data?.payload?.events);
      setLoading(false);
    } catch (error) {
      if (error?.response?.status === 404) {
        setGetEventData();
      }
      toast.error(error);
      setLoading(false);
    }
  };

  const handleGetAllPlates = async () => {
    setIsShowManageModel(true);
    try {
      const response = await ApiGet(`dahuaAuthPlates/getAllAuthPlates?locationId=${id}`);
      setInputValue({ ...inputValue, authPlates: [...response?.data?.payload, { id: 1, plateNumber: "" }] });
      // if (isAddSingle) {
      //   setInputValue({ ...inputValue, authPlates: [...response?.data?.payload, { id: 1, plateNumber: "" }] });
      // } else {
      //   setInputValue({ ...inputValue, authPlates: response?.data?.payload });
      // }
      setLoading(false);
    } catch (error) {
      if (error?.response?.status === 404) {
        setInputValue({
          ...inputValue,
          authPlates: [{ id: 1, plateNumber: "" }],
        });
      } else {
        toast.error(error?.message || "Something went wrong");
      }
      setLoading(false);
    }
  };

  const handleViewAllPlates = async () => {
    setIsShowPlateModels(true);
    try {
      const response = await ApiGet(`dahuaAuthPlates/getAllAuthPlates?locationId=${id}`);
      setAllPlatesValue({ ...allPlatesValue, authPlates: response?.data?.payload });
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const customNoDataComponent = () => <div style={{ textAlign: "center", padding: "10px 0px", fontSize: "16px" }}>Aktuell sind keine Daten vorhanden.</div>;

  const handleAddNewsClose = () => {
    setIsShowManageModel(false);
    setIsShowPlateModels(false);
    // setAddUpdateLoader(false);
    setInputValue({ authPlates: [{ id: 1, plateNumber: "" }] });
    setAllPlatesValue([]);
    setError({});
  };

  const handleClosePlateModel = () => {
    setIsShowPlateModels(false);
    setAllPlatesValue([]);
    setError({});
    setDonwloadModel({
      isOpen: false,
      startDate: null,
      endDate: null,
      violateOption: null,
      loading: false,
    });
  };

  const handleOnChange = (dates, name) => {
    const [start, end] = dates;
    if (name === "forFilter") {
      setStartDate(start);
      setEndDate(end);
      if (end) {
        const params = { ...filterData, startDate: moment(start).format("YYYY-MM-DD"), endDate: moment(end).format("YYYY-MM-DD") };
        setFilterData(params);
      }
    } else if (name === "forDownload") {
      setDonwloadModel({ ...donwloadModel, startDate: start, endDate: end });
    }
  };

  const handleChangeAssign = (data, name) => {
    if (name === "forFilter") {
      setViolateOption(data);
    } else if (name === "forDownload") {
      setDonwloadModel({ ...donwloadModel, violateOption: data });
    }
  };

  return (
    <div>
      <div className="card p-1">
        <div className="p-2 mb-2">
          <div className="standortdetails">
            <div className="standortdetails-head">
              <svg style={{ cursor: "pointer" }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width={22} height={22} onClick={() => window.history.back()}>
                <path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z" />
              </svg>
              <h2 className="pl-3 pt-2">Standortdetails</h2>
            </div>
            <div className="standortdetails-content">
              <div className="col d-flex align-items-center" style={{ gap: "10px 20px", flexWrap: "wrap" }}>
                <div className={` reactDatePicker`}>
                  <DatePicker
                    selected={startDate}
                    startDate={startDate}
                    endDate={endDate}
                    dateFormat="dd/MM/yyyy"
                    placeholderText="Datum"
                    maxDate={new Date()}
                    onChange={(e) => handleOnChange(e, "forFilter")}
                    onKeyDown={(e) => e.preventDefault()}
                    selectsRange
                    fixedHeight
                  />
                </div>

                <div className="project-Dropdown project-Dropdown-sc">
                  <Select
                    className="Select-main"
                    // menuIsOpen={true}
                    value={violateOption}
                    name="isAssign"
                    onChange={(e) => handleChangeAssign(e, "forFilter")}
                    options={isAssignViolateOption}
                    // styles={ProjectStyle}
                    defaultValue={violateOption}
                    placeholder="Abstrafungen"
                    isClearable={true}
                  />
                </div>

                <div className="search-input">
                  <input
                    type="search"
                    className={`form-control form-control-lg form-control-solid `}
                    onChange={(e) => {
                      setSearchValue(e.target.value);
                      setLoading(true);
                    }}
                    name="search"
                    value={searchValue}
                    placeholder="Suche"
                    style={{ maxHeight: "40px" }}
                  />
                </div>
                {/* <button
                  onClick={() => {
                    handleViewAllPlates();
                  }}
                  className="btn btn addbutton"
                  style={{ whiteSpace: "nowrap" }}
                >
                  Alle Kennzeichen ansehen
                </button>
                <button
                  onClick={() => {
                    handleGetAllPlates();
                  }}
                  className="btn btn addbutton"
                  style={{ whiteSpace: "nowrap" }}
                >
                  Kennzeichen verwalten
                </button>
                <div
                  onClick={() => {
                    setDonwloadModel({
                      isOpen: true,
                      startDate: null,
                      endDate: null,
                      violateOption: null,
                      loading: false,
                    });
                  }}
                  style={{ justifyContent: "center", alignItems: "center", display: "flex", cursor: "pointer" }}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width={25} height={25} viewBox="0 0 512 512" fill="#FFDF5C">
                    <path d="M256 464a208 208 0 1 1 0-416 208 208 0 1 1 0 416zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM376.9 294.6c4.5-4.2 7.1-10.1 7.1-16.3c0-12.3-10-22.3-22.3-22.3L304 256l0-96c0-17.7-14.3-32-32-32l-32 0c-17.7 0-32 14.3-32 32l0 96-57.7 0C138 256 128 266 128 278.3c0 6.2 2.6 12.1 7.1 16.3l107.1 99.9c3.8 3.5 8.7 5.5 13.8 5.5s10.1-2 13.8-5.5l107.1-99.9z" />
                  </svg>
                </div> */}
              </div>
            </div>
          </div>
          <DataTable
            data={getEventData}
            columns={columns}
            responsive
            noDataComponent={customNoDataComponent()}
            customStyles={customStyles}
            highlightOnHover
            pagination
            paginationServer
            paginationTotalRows={count}
            className="new_data__table table_height"
            paginationPerPage={countPerPage}
            paginationRowsPerPageOptions={[5, 10, 20, 25, 50]}
            paginationDefaultPage={page}
            progressPending={loading}
            progressComponent={
              <div className="LoadinComponent">
                <TailSpin color="#334D52" height={30} width={30} />
              </div>
            }
            onChangePage={(page) => {
              setPage(page);
            }}
            onChangeRowsPerPage={(rowPerPage) => {
              setCountPerPage(rowPerPage);
            }}
            fixedHeader
          />
        </div>


        <Modal show={isShowPlateModels} onHide={handleClosePlateModel} className="d-flex justify-content-center align-items-center addplatesmodalmainalignment">
          <div className="modal-content new-model-conent-sye" style={{ maxHeight: "600px", overflow: "auto" }}>
            <Modal.Header className="justify-content-start d-flex align-items-center" closeButton>
              <Modal.Title style={{ color: "#FFDF5C" }}>Alle Kennzeichen </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ height: "auto" }}>
              {allPlatesValue?.authPlates?.length ? (
                <div className="dynamic-inputs">
                  <Label className="form-label">Nummernschilder</Label>
                  {allPlatesValue?.authPlates?.map((input, index) => (
                    <div key={input.id}>
                      <div className="d-flex align-items-center mb-2">
                        <Input placeholder={`Kennzeichen ${index + 1}`} value={input?.plateNumber} disabled={true} />
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                customNoDataComponent()
              )}
            </Modal.Body>
            <Modal.Footer>
              <Button className="activebutton h-40px" onClick={handleAddNewsClose} style={{ marginRight: "15px" }}>
                Schließen
              </Button>
            </Modal.Footer>
          </div>
        </Modal>

        {/* {donwloadModel?.isOpen && (
          <DownloadFilterModel donwloadModel={donwloadModel} setDonwloadModel={setDonwloadModel} handleCloseDownloadModel={handleClosePlateModel} handleOnChange={handleOnChange} handleChangeAssign={handleChangeAssign} id={id} />
        )} */}
      </div>
    </div>
  );
}

export default LocationDetails;
